/**
 * Syncs Boost AI Search & Discovery (boost-sd) filter checkboxes with the current URL.
 * Boost renders the tick via .boost-sd__filter-option-item-button--selected on the button
 * (see main.css), not via aria-checked or .selected on the <li>.
 */
(function () {
  var PROPERTY_TYPE_KEY = 'pf_m_::property_primary::property_type';
  var SELECTED_BTN_CLASS = 'boost-sd__filter-option-item-button--selected';

  function normalizeFilterKey(k) {
    if (!k) return '';
    var key = k;
    try {
      for (var i = 0; i < 3; i++) {
        var next = decodeURIComponent(key.replace(/\+/g, ' '));
        if (next === key) break;
        key = next;
      }
    } catch (e) {}
    return key.replace(/%3A/gi, ':');
  }

  function collectPropertyTypeValuesFromUrl() {
    var wanted = [];
    var seen = Object.create(null);
    try {
      var p = new URLSearchParams(window.location.search);
      p.forEach(function (v, k0) {
        var k = normalizeFilterKey(k0);
        if (k !== PROPERTY_TYPE_KEY) return;
        var val;
        try {
          val = decodeURIComponent(String(v).replace(/\+/g, ' ')).trim();
        } catch (e2) {
          val = String(v).trim();
        }
        var lower = val.toLowerCase();
        if (!seen[lower]) {
          seen[lower] = true;
          wanted.push(lower);
        }
      });
    } catch (e3) {}
    return wanted;
  }

  function sync() {
    var wanted = collectPropertyTypeValuesFromUrl();

    var buttons = document.querySelectorAll(
      'li.boost-sd__filter-option-item button.boost-sd__filter-option-item-button[role="checkbox"][data-action*="property_type"]'
    );
    if (!buttons.length) return;

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var label = btn.querySelector('.boost-sd__filter-option-item-label');
      var text = (label && label.textContent ? label.textContent : '').trim().toLowerCase();
      if (!text) continue;

      var isWanted = wanted.length > 0 && wanted.indexOf(text) !== -1;
      if (isWanted) {
        btn.classList.add(SELECTED_BTN_CLASS);
        btn.setAttribute('aria-checked', 'true');
      } else {
        btn.classList.remove(SELECTED_BTN_CLASS);
        btn.setAttribute('aria-checked', 'false');
      }
    }
  }

  var debounceTimer;
  function debouncedSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, 50);
  }

  function runScheduled() {
    sync();
    [80, 250, 700, 1800].forEach(function (ms) {
      setTimeout(sync, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runScheduled);
  } else {
    runScheduled();
  }

  if (typeof MutationObserver !== 'undefined') {
    var mo = new MutationObserver(debouncedSync);
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
